import React from 'react';
import { connect } from 'react-redux';
import { setDialogs } from '../../../actions';
import { loginAction, signInAction, doPreProcess, setWelfareAnimation } from '../../../rootStore';
import './index.scss';

class SignInGuideDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 0,
      value: 0,
      sum: {
        vip: 0,
        cash: 0,
        coin: 0,
      },
    };
    this.Log = this.props.Log;
  }

  componentDidMount() {
    const { signTask } = this.props;
    const { stepWelfare = [], completed = 0, isContinueTask, continueTaskDays = 0 } = signTask;
    const taskDays = isContinueTask ? continueTaskDays : completed;
    const welfare = stepWelfare[taskDays > 0 ? taskDays - 1 : 0];
    const sumCount = this.state.sum;

    if (welfare && welfare.welfareInfo && welfare.welfareInfo.welfareType) {
      this.setState({
        type: welfare.welfareInfo.welfareType,
        value: welfare.welfareInfo.value || 0,
      });
    }

    // 计算活动获得总奖励
    for (let i = 0, len = stepWelfare.length ; i < len ; i ++) {
      const { welfareInfo } = stepWelfare[i];
      const { value, welfareType, max = 0 } = welfareInfo;

      if (welfareType === 6) {  // 卡券奖励
        sumCount.vip += value;
      } else if (welfareType === 4) {  // 现金奖励
        sumCount.cash += value;
      } else if (welfareType === 0) {  // 随机现金奖励
        sumCount.cash += max;
      } else if (welfareType === 5) {  // 金币奖励
        sumCount.coin += value;
      } else if (welfareType === 3) {  // 随机金币奖励
        sumCount.coin += max;
      }
    }

    this.setState({
      sum: sumCount,
    });
  }

	close = () => {
	  this.props.dialogs.pop();
	  this.props.dispatch(setDialogs(this.props.dialogs));

	  setWelfareAnimation();
	}

	login = () => {
	  this.props.dialogs.pop();
	  loginAction();
	}

	contentRender = () => {
	  if (this.props.type === 'vip') {
	    return (
				<div className="dialog vip">
					<div className="board">
						<div className="congra">恭喜获得<span>{this.state.sum.vip}</span>天VIP会员</div>
						<div className="vip14"></div>
						<div className="getTip">连续签到<span>7</span>天可得</div>
						{this.props.isLogin
						  ? <div className="btn" log-click-eltype="vipsign" log-click-elname="vipsign_popup_login_confirm" onClick={() => doPreProcess(signInAction)('vip')}>立即签到</div>
						  :	<div className="btn" onClick={() => this.login()}>登录后立即签到</div>
						}
					</div>
					<div className="close2" onClick={() => this.close()}></div>
				</div>
	    );
	  } if (this.props.type === 'cash') {
	    return (
				<div className="dialog cash">
					<div className="board">
						<div className="congra">恭喜获得最高</div>
						<div className="cash"><span className="num">{(this.state.sum.cash / 100).toFixed(2)}</span>元</div>
						{this.props.from !== 'siginCoin'
							&& <div className="getTip">连续签到<span>7</span>天可得</div>
						}
						{this.props.isLogin
						  ? <div className="btn" onClick={() => doPreProcess(signInAction)('cash')}>立即签到</div>
						  :							<div className="btn" onClick={() => this.login()}>登录后立即签到</div>
						}
					</div>
					<div className="close2" onClick={() => this.close()}></div>
				</div>
	    );
	  }
	  return (
				<div className="dialog">
					<div className="close" onClick={this.close} log-click-elname={`defaultsign_popup_${this.props.isLogin ? 'login' : 'unlogin'}_cancel`} log-click-eltype="defaultsign"></div>
					{!this.props.isLogin && this.props.testBucket >= 20 ? this.experContent() : this.defaultContent() }
					{this.props.isLogin
					  ? <div className="btn" onClick={() => doPreProcess(signInAction)('defaultsign')} log-click-elname="defaultsign_popup_login_confirm" log-click-eltype="defaultsign">立即签到</div>
					  :						<div className={`btn ${this.props.testBucket >= 100 ? 'exper2' : ''}`} onClick={() => this.login()} log-click-elname="defaultsign_popup_unlogin_confirm" log-click-eltype="defaultsign">
							{this.props.testBucket >= 20
							  ? '登录领取'
							  :	'登录后立即签到'
							}
						</div>
					}
				</div>
	  );
	}

	// 弹窗实验
	experContent = () => {
	  if (this.state.type === 6) {  // 卡券奖励
	    return (
				<React.Fragment>
					<div className="vipchahua"></div>
					<div className="successTip">今日签到奖励<span>{this.state.value}</span>天腾讯视频VIP</div>
				</React.Fragment>
	    );
	  } if (this.state.type === 2 || this.state.type === 1) {  // 礼券广告
	    return (
				<React.Fragment>
					<div className="lotterychahua"></div>
					<div className="successTip">今日签到获得随机礼包</div>
				</React.Fragment>
	    );
	  }
	  if (this.state.sum.cash) { // 如果出现现金奖励取累计现金奖励，否则取累计金币奖励
	    return (
					<React.Fragment>
						<div className="cashchahua"></div>
						<div className="successTip">最高可得<span>{this.state.sum.cash / 100}</span>元现金</div>
					</React.Fragment>
	    );
	  }
	  return (
					<React.Fragment>
						<div className={`chahua ${this.props.testBucket >= 100 ? 'exper2' : ''}`}></div>
						<div className="successTip">最高可得<span>{this.state.sum.coin}</span>金币</div>
					</React.Fragment>
	  );
	}

	defaultContent = () => {
	  if (this.state.type === 6) {  // 卡券奖励
	    return (
				<React.Fragment>
					<div className="vipchahua"></div>
					<div className="successTip">今日签到奖励<span>{this.state.value}</span>天腾讯视频VIP</div>
				</React.Fragment>
	    );
	  } if (this.state.type === 0) {  // 随机现金奖励
	    return (
				<React.Fragment>
					<div className="cashchahua"></div>
					<div className="successTip">今日签到获随机奖励</div>
				</React.Fragment>
	    );
	  } if (this.state.type === 4) {  // 固定现金奖励
	    return (
				<React.Fragment>
					<div className="cashchahua"></div>
					<div className="successTip">今日签到奖励<span>{this.state.value / 100}</span>元现金</div>
				</React.Fragment>
	    );
	  } if (this.state.type === 3) {  // 随机金币奖励
	    return (
				<React.Fragment>
					<div className="chahua"></div>
					<div className="successTip">今日签到获随机奖励</div>
				</React.Fragment>
	    );
	  } if (this.state.type === 5) {  // 固定金币奖励
	    return (
				<React.Fragment>
					<div className="chahua"></div>
					<div className="successTip">今日签到奖励<span>{this.state.value}</span>金币</div>
				</React.Fragment>
	    );
	  } if (this.state.type === 2 || this.state.type === 1) {  // 礼券广告
	    return (
				<React.Fragment>
					<div className="lotterychahua"></div>
					<div className="successTip">今日签到获得随机礼包</div>
				</React.Fragment>
	    );
	  }
	}

	render() {
	  return (
			<div className="signInGuideDialog">
				{this.contentRender()}
			</div>
	  );
	}
}

const mapStateToProps = (state) => {
  const { dialogs, signTask, isLogin, testBucket } = state;
  return {
    dialogs,
    signTask,
    isLogin,
    testBucket,
  };
};

export default connect(mapStateToProps)(SignInGuideDialog);
